export { default as TabHeaderProduct } from './Product.tab';
export { default as TabHeaderHistory } from './History.tab';
export { default as TabHeaderInfo } from './Info.tab';
